import React from "react";
import { Form, Col, OverlayTrigger, Tooltip } from "react-bootstrap";

/**
 * Reusable textarea field component
 */
const TextAreaField = ({
  // Field props
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  rows = 4,
  maxLength,

  // Validation props
  error,
  errorMessage,
  validationErrors = [],

  // Layout props
  colProps = {},
  className = "form-control",

  // Tooltip props
  tooltip,
  tooltipIcon,

  // Other props
  disabled = false,
  readOnly = false,
  ...otherProps
}) => {
  const renderTooltip = (props) => (
    <Tooltip id="textarea-tooltip" {...props}>
      {tooltip}
    </Tooltip>
  );

  return (
    <Col {...colProps} className={tooltip ? "position-relative" : ""}>
      {tooltip && tooltipIcon && (
        <span
          className="ques-info-icon"
          style={{ cursor: "pointer", float: "right" }}
        >
          <OverlayTrigger
            placement="right"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip}
          >
            <img
              style={{
                width: "15px",
                bottom: "30px",
                position: "absolute",
                marginLeft: "4px",
              }}
              src={tooltipIcon}
              alt="Help"
            />
          </OverlayTrigger>
        </span>
      )}
      <div className="form-group">
        <Form.Control
          as="textarea"
          name={name}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onBlur={(e) => onBlur && onBlur(e.target.value)}
          placeholder={placeholder}
          rows={rows}
          maxLength={maxLength}
          className={`inputclass form-control ${className}`}
          disabled={disabled}
          readOnly={readOnly}
          {...otherProps}
        />
      </div>
      {error && <p style={{ color: "red" }}>{errorMessage}</p>}
      {validationErrors.map(
        (validationError, index) =>
          validationError.condition && (
            <p key={index} style={{ color: "red" }}>
              {validationError.message}
            </p>
          )
      )}
    </Col>
  );
};

export default TextAreaField;
